/**************************************时间格式化处理************************************/
global.dateFtt = function(fmt, date) {
  if (!(date instanceof Date)) {
    console.log("时间格式错误: " + JSON.stringify(date));
    return "";
  }
  var o = {
    "M+": date.getMonth() + 1, //月份   
    "d+": date.getDate(), //日   
    "h+": date.getHours(), //小时   
    "m+": date.getMinutes(), //分   
    "s+": date.getSeconds(), //秒   
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
    "S": date.getMilliseconds() //毫秒   
  };
  if (date.getFullYear() == "1970") {
    return "";
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

global.MQTT_SERVICE = 'wss://www.jpnbmeter.com/ws' // mqtt服务地址
global.MQTT_USERNAME = 'hawi' // mqtt连接用户名
global.MQTT_PASSWORD = 'hawi2019' // mqtt连接密码

// global.MQTT_SERVICE = 'ws://58.59.64.11:15674/ws' // mqtt服务地址
// global.MQTT_USERNAME = 'guest' // mqtt连接用户名
// global.MQTT_PASSWORD = 'guest' // mqtt连接密码


// global.meterType = ["水表","流量计"]


global.meterType = function() {
  console.log("heihei " +  localStorage.getItem('userMeterType'));
  if(localStorage.getItem('userMeterType') == 0){
    return ["水表","流量计"];
  }
  if(localStorage.getItem('userMeterType') == 1){
    return ["热量表"];
  }

  return ["水表","流量计","热量表"];
}
//表具类型 0:水表与流量计，1：热量表，2：动态平衡阀，3：消防栓，4：压力开关、流量开关，5：流量计
global.getMeterType = function(type) {
  console.log("heihei " +  localStorage.getItem('userMeterType'));
  if(type == 0){
    return ["水表"];
  }
  if(type == 1){
    return ["热量表"];
  }
  if(type == 5){
    return ["流量计"];
  }

  return ["水表","流量计","热量表"];
}

global.getRealMeterType = function(type) {
  console.log("heihei " +  localStorage.getItem('userMeterType'));
  if(type == 0){
    return ["水表", "流量计"];
  }
  if(type == 1){
    return ["热量表"];
  }
  if(type == 5){
    return ["流量计"];
  }

  return ["水表","流量计","热量表"];
}

global.searchMeterType = function() {
  console.log("heihei " +  localStorage.getItem('userMeterType'));
  if(localStorage.getItem('userMeterType') == 0){
    return undefined;
  }
  if(localStorage.getItem('userMeterType') == 1){
    return "热量表";
  }
  if(localStorage.getItem('userMeterType') == 5){
    return "流量计";
  }

  return undefined;
}

global.stateContrast = {
  "阀门状态": "异常",
  "表具电池电压": "欠压",
  "进水温度传感器": "故障",
  "出水温度传感器": "故障",
  "流量传感器": "故障",
  "空管": "空管",
  "水管爆裂故障": "故障",
  "水管泄漏故障": "故障",
  "管道装反": "装反",
  "集抄器电池电压": "欠压",
  "本次采集": "失败",
  "上限报警": "报警",
  "下限报警": "报警"
}
